import { createStore } from 'vuex'

import cycle from './modules/cycle'
import initial from './modules/initial'
import plan from './modules/plan'
import followup from './modules/followup'
import summary from './modules/summary'
import general_info from './modules/general_info'
import general_comment from './modules/general_comment'

export default createStore({
  modules: {
    cycle,
    initial,
    plan,
    followup,
    summary,
    general_info,
    general_comment
  }
})
